import { AddMealToSlotRequest } from "@/clients/models/AddMealToSlotRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAddMealSlot = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.PLAN_ADD_MEAL_SLOT],
    mutationFn: async (requestBody: AddMealToSlotRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.addMealToSlotApiV1PlansMealsPost(user.id, requestBody);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CALORIE_BUDGET] });
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes(QueryKeys.BALANCE_CALORIES) ||
          query.queryKey.includes(QueryKeys.BALANCE_PROTEIN),
      });
    },
  });

  return {
    addMealSlot: mutate,
    addMealSlotAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
